var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blockquote',[_c('p',[_vm._v(" e-mail: "+_vm._s(_vm.form.tasks_data['FETCH_EXTERNAL_USER_ID']['input']['email'])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }